import React, { createContext, PropsWithChildren } from 'react';
import { Blocker, useBlocker } from 'react-router-dom';

type ContextProps = {
  blocker?: Blocker;
  unBlock?: (blocker: Blocker) => void;
  disabled?: boolean;
};
export const BlockerContext = createContext({} as ContextProps);

interface Props {
  value: ContextProps;
}

export const BlockerContextProvider = ({ value, children }: PropsWithChildren<Props>) => {
  const blocker = useBlocker(({ currentLocation, nextLocation }) => currentLocation.pathname !== nextLocation.pathname);

  return <BlockerContext.Provider value={{ ...value, blocker }}>{children}</BlockerContext.Provider>;
};
